import moment from "moment";
import StatusCustom from "../../../../components/status/statusCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { dateTimeToView } from "../../../../utils/date.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import { useNavigate } from "react-router-dom";
import { routeName } from "../../../../routes/routeName";
import { OnlineCourseApi, onlineCourseFormList } from "../../../../api/online-corse/online_course.api";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";
import { STATUS_ONLINE_COURSE_FORM, STATUS_ONLINE_COURSE_FORM_TYPE } from "./enum/manage_surveys.enum";



export const ManageState = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);
    const [keyword, setKeyword] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);


    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const headCells = [
        {
            id: "subject_no", width: 70, sortable: false, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อแบบสำรวจ")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", className: "px-4", width: 120, class: matches && data.length > 0, label: t("สถานะ")
        },
    ];
    const renderStatus = (status: string) => {
        if (status === STATUS_ONLINE_COURSE_FORM.DRAFT) {
            return "บันทึกร่าง" // i18n-ignore: status key for StatusCustom (color id; StatusCustom translates the text)
        } else if (status === STATUS_ONLINE_COURSE_FORM.ACTIVE) {
            return "ใช้งาน" // i18n-ignore: status key for StatusCustom (color id; StatusCustom translates the text)
        }
        return ""
    }
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            created_date,
            modified_date,
            created_by,
            id_online_course_form,
            modifier_name,
            online_course_form_name,
            status,
            online_course_form_status
        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: online_course_form_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: created_by || modifier_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateTimeToView(modified_date || created_date) || "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-between items-center'>
                        <span className="w-full">
                            <StatusCustom
                                text={renderStatus(online_course_form_status)}
                                type={renderStatus(online_course_form_status)}
                            />
                        </span>
                        <span className="w-full">
                            <OptionsButtonCustom
                                enableEdit
                                enableView
                                enableDelete
                                onEditClick={() => navigate(routeName.cms.course_online_surveys_detail.replace(":id", id_online_course_form))}
                                onViewClick={() => navigate(routeName.cms.course_online_surveys_view.replace(":id", id_online_course_form))}
                                onDeleteClick={() => handleDeleteList(id_online_course_form)}
                            />
                        </span>
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_online_course_form: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await OnlineCourseApi.deleteForm(id_online_course_form).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อยแล้ว"));
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ เรียบร้อยแล้ว"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: onlineCourseFormList = {
            page: page,
            limit: pageLimit,
            type: STATUS_ONLINE_COURSE_FORM_TYPE.MANAGE_SURVEY,
        }
        dispatch(setLoading());
        if (keyword) query = { ...query, keyword: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        await OnlineCourseApi.formList(query).then((res) => {
            if (res.status < 300) {
                const data_item = res.data?.data?.items || [];
                const total_item = res.data?.data?.meta?.totalItems || [];
                setData(data_item);
                setTotalItems(total_item)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, endDate, startDate, keyword])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
    }
}